var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfile8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.091,8.15901c0.87868,0.87868 0.87868,2.3033 0,3.18198c-0.87868,0.87868 -2.3033,0.87868 -3.18198,0c-0.87868,-0.87868 -0.87868,-2.3033 0,-3.18198c0.87868,-0.87868 2.3033,-0.87868 3.18198,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,18.5v-12.959c0,-1.127 0.914,-2.041 2.041,-2.041h15.959c1.105,0 2,0.895 2,2v13c0,1.105 -0.895,2 -2,2h-16c-1.105,0 -2,-0.895 -2,-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9.5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,13.5h-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.095,16.5c-0.175,-0.439 -0.445,-0.833 -0.792,-1.154v0c-0.587,-0.544 -1.357,-0.846 -2.157,-0.846h-1.292c-0.8,0 -1.57,0.302 -2.157,0.846v0c-0.347,0.321 -0.617,0.715 -0.792,1.154"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile8);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/UserProfile.8.69db6082b828b96db83e08e8e8afb8d7.svg";
export { MemoForwardRef as ReactComponent };